/** 各语言文案；about.body 控制在 300 字以内 */
export const messages = {
  'zh-CN': {
    meta: { versionLabel: 'v3.1', pageTitle: '黑白棋 Othello v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: '界面语言' },
    help: { aboutAria: '关于黑白棋' },
    dialog: { close: '关闭' },
    about: {
      title: '黑白棋简介',
      body:
        '黑白棋（奥赛罗 Othello）由十九世纪末英国的「Reversi 翻转棋」演变而来。1971 年日本长谷川五郎推出奥赛罗品牌并统一规则：双方在 8×8 格轮流落子，只要新子与对方棋子之间连成直线且两端为己方，则中间的对方棋子全部翻为已方。双方都无法落子时棋局结束，棋子多者胜。规则简明、变化极多，易学难精，已成为世界性竞技与益智项目。'
    },
    status: {
      toMove: '等待 {name} 落子，已思考 {sec} 秒'
    },
    game: {
      skipLine: '{who} 无子可落，跳过',
      resultDraw: '平局！',
      resultNamedWin: '{name} 获胜！'
    },
    roles: { you: '你', ai: 'AI', black: '黑棋', white: '白棋', youBlack: '你（黑）', aiWhite: 'AI（白）' },
    player: {
      sectionTitle: '玩家名称',
      labelBlack: '黑方',
      labelWhite: '白方',
      default1: '玩家1',
      default2: '玩家2'
    },
    mode: { pvp: '双人对战', pvc: '人机对战', pvn: '网络对战', moveAssist: '落子辅助' },
    network: {
      namePlaceholder: '输入玩家名称',
      roomPlaceholder: '房间号',
      join: '加入',
      leave: '离开',
      opponent: '对手：',
      idle: '请输入房间号并点击加入。',
      connecting: '连接中...',
      ready: '已就绪，等待对手加入。',
      matchedCountdown: '配对成功，{sec} 秒后自动开局。',
      playing: '联网对战进行中。',
      waitingRematch: '等待对方同意。',
      closed: '连接已断开。',
      invalidRoomCode: '房间号需为6位数字。',
      roomFull: '房间已满，请更换房间号。',
      nameTaken: '该玩家名已在房间中使用，请更换用户名后重新加入。',
      rematchInviteConfirm: '对方邀请您再来一局。点击“确定”同意，点击“取消”退出房间。',
      partnerDisconnected: '对手已暂时断开，等待对方重新加入…',
      partnerLeft: '对手已退出房间，等待对方重新加入…',
      error: '网络错误：'
    },
    scoreboard: { blackPvp: '黑棋', whitePvp: '白棋', youBlack: '你（黑）', aiWhite: 'AI（白）', vs: 'vs' },
    side: {
      moveListAria: '手顺记录',
      title: '对局进程',
      legendBoard:
        '棋盘上数字为当手序号；带下划线表示该子在本手被翻转占有。',
      legendReplay: ' 终局后可点选手顺或「初始局面」复盘。',
      initial: '初始局面',
      initialHint: '开局四子',
      moveNo: '第 {n} 手',
      flipCount: '翻转 {c} 子',
      finalTitle: '终局',
      scoreLine: '黑 {b} — 白 {w}',
      playAgain: '再来一局',
      restart: '重开',
      replayNav: '复盘步进',
      prevStep: '上一步',
      nextStep: '下一步',
      exportJson: '导出 JSON',
      importJson: '导入 JSON',
      importFailed: '导入失败：',
      importOk: '棋谱已导入。',
      saveLocal: '保存',
      saveOk: '已保存到浏览器。',
      savedBrowserTitle: '浏览器存档',
      saveListEmpty: '暂无存档，有手顺时可点「保存」。',
      reviewBrowserSave: '复盘',
      deleteBrowserSave: '删除',
      savedMoveCount: '{n} 手',
      saveQuota: '浏览器存储已满，无法保存。可删除旧存档后再试。',
      confirmDeleteSave: '删除该存档？'
    }
  },
  'zh-TW': {
    meta: { versionLabel: 'v3.1', pageTitle: '黑白棋 Othello v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: '介面語言' },
    help: { aboutAria: '關於黑白棋' },
    dialog: { close: '關閉' },
    about: {
      title: '黑白棋簡介',
      body:
        '黑白棋（奧賽羅 Othello）源自十九世紀末英國的「Reversi 翻轉棋」。1971 年日本長谷川五郎推出奧賽羅品牌並統一規則：雙方在 8×8 格輪流落子，只要新子與對方棋子成一直線且兩端為己方，則中間對方棋子全數翻為己方。雙方皆無法落子時棋局結束，子多者勝。規則簡明、變化極多，易學難精，已成為世界性益智與競技項目。'
    },
    status: {
      toMove: '等待 {name} 落子，已思考 {sec} 秒'
    },
    game: {
      skipLine: '{who} 無子可落，跳過',
      resultDraw: '平手！',
      resultNamedWin: '{name} 獲勝！'
    },
    roles: { you: '你', ai: 'AI', black: '黑棋', white: '白棋', youBlack: '你（黑）', aiWhite: 'AI（白）' },
    player: {
      sectionTitle: '玩家名稱',
      labelBlack: '黑方',
      labelWhite: '白方',
      default1: '玩家1',
      default2: '玩家2'
    },
    mode: { pvp: '雙人對戰', pvc: '人機對戰', moveAssist: '落子輔助' },
    scoreboard: { blackPvp: '黑棋', whitePvp: '白棋', youBlack: '你（黑）', aiWhite: 'AI（白）', vs: 'vs' },
    side: {
      moveListAria: '手順記錄',
      title: '對局進程',
      legendBoard:
        '棋盤上數字為當手序號；帶底線表示該子在本手被翻轉占有。',
      legendReplay: ' 終局後可點選手順或「初始局面」複盤。',
      initial: '初始局面',
      initialHint: '開局四子',
      moveNo: '第 {n} 手',
      flipCount: '翻轉 {c} 子',
      finalTitle: '終局',
      scoreLine: '黑 {b} — 白 {w}',
      playAgain: '再來一局',
      restart: '重開',
      replayNav: '複盤步進',
      prevStep: '上一步',
      nextStep: '下一步',
      exportJson: '匯出 JSON',
      importJson: '匯入 JSON',
      importFailed: '匯入失敗：',
      importOk: '棋譜已匯入。',
      saveLocal: '保存',
      saveOk: '已存到瀏覽器。',
      savedBrowserTitle: '瀏覽器存檔',
      saveListEmpty: '尚無存檔；有手順時可點「保存」。',
      reviewBrowserSave: '複盤',
      deleteBrowserSave: '刪除',
      savedMoveCount: '{n} 手',
      saveQuota: '瀏覽器儲存空間已滿，無法保存。刪除舊存檔後再試。',
      confirmDeleteSave: '刪除此存檔？'
    }
  },
  en: {
    meta: { versionLabel: 'v3.1', pageTitle: 'Othello (Reversi) v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: 'Language' },
    help: { aboutAria: 'About Othello' },
    dialog: { close: 'Close' },
    about: {
      title: 'About Othello / Reversi',
      body:
        'Othello descends from the late‑19th‑century English game Reversi. In 1971 Goro Hasegawa in Japan launched the modern “Othello” brand with standardized rules: two players alternate placing discs on an 8×8 board; any opponent discs sandwiched in a straight line between the new disc and an existing friendly disc flip to your color. When neither side has a legal move, the game ends and the player with more discs wins. Simple rules, deep strategy—it is played worldwide as a classic abstract game.'
    },
    status: {
      toMove: 'Waiting for {name} to move, thinking {sec}s'
    },
    game: {
      skipLine: '{who} has no legal move. Skip.',
      resultDraw: 'Draw!',
      resultNamedWin: '{name} wins!'
    },
    roles: {
      you: 'You',
      ai: 'AI',
      black: 'Black',
      white: 'White',
      youBlack: 'You (Black)',
      aiWhite: 'AI (White)'
    },
    player: {
      sectionTitle: 'Display names',
      labelBlack: 'Black',
      labelWhite: 'White',
      default1: 'Player 1',
      default2: 'Player 2'
    },
    mode: { pvp: 'Two players', pvc: 'vs AI', moveAssist: 'Move assist' },
    scoreboard: {
      blackPvp: 'Black',
      whitePvp: 'White',
      youBlack: 'You (B)',
      aiWhite: 'AI (W)',
      vs: 'vs'
    },
    side: {
      moveListAria: 'Move list',
      title: 'Moves',
      legendBoard:
        'Numbers show the move when a disc gained its color; underlined = flipped on that move.',
      legendReplay: ' After the game ends, tap a move or “Start” to review.',
      initial: 'Start position',
      initialHint: 'Four opening discs',
      moveNo: 'Move {n}',
      flipCount: 'Flipped {c}',
      finalTitle: 'Result',
      scoreLine: 'Black {b} — White {w}',
      playAgain: 'Play again',
      restart: 'Restart',
      replayNav: 'Review',
      prevStep: 'Previous',
      nextStep: 'Next',
      exportJson: 'Export JSON',
      importJson: 'Import JSON',
      importFailed: 'Import failed:',
      importOk: 'Record imported.',
      saveLocal: 'Save',
      saveOk: 'Saved in this browser.',
      savedBrowserTitle: 'Browser saves',
      saveListEmpty: 'No saves yet. Save when you have moves on the board.',
      reviewBrowserSave: 'Review',
      deleteBrowserSave: 'Delete',
      savedMoveCount: '{n} moves',
      saveQuota: 'Browser storage is full. Delete an old save and try again.',
      confirmDeleteSave: 'Delete this save?'
    }
  },
  ja: {
    meta: { versionLabel: 'v3.1', pageTitle: 'オセロ Othello v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: '表示言語' },
    help: { aboutAria: 'オセロについて' },
    dialog: { close: '閉じる' },
    about: {
      title: 'オセロ（リバーシ）について',
      body:
        '現代のオセロは、19世紀末のイギリスで遊ばれた「リバーシ」を源流とし、1971年に日本の長谷川五郎氏が商品化・ルール統一しました。8×8の盤で交互に石を打ち、打った石と既に自分の色の石とのあいだに相手の石が一直線に挟まれると、その相手の石はすべて裏返ります。双方とも合法手がなくなったら終了し、多い方の勝ちです。短時間で深い読みが求められる世界的なボードゲームです。'
    },
    status: {
      toMove: '{name}の着手待ち、思考 {sec} 秒'
    },
    game: {
      skipLine: '{who}は打てる場所がありません。パス。',
      resultDraw: '引き分け！',
      resultNamedWin: '{name}の勝ち！'
    },
    roles: {
      you: 'あなた',
      ai: 'AI',
      black: '黒',
      white: '白',
      youBlack: 'あなた（黒）',
      aiWhite: 'AI（白）'
    },
    player: {
      sectionTitle: '表示名',
      labelBlack: '黒',
      labelWhite: '白',
      default1: 'プレイヤー1',
      default2: 'プレイヤー2'
    },
    mode: { pvp: '対人戦', pvc: '対コンピュータ', moveAssist: '着手補助' },
    scoreboard: {
      blackPvp: '黒',
      whitePvp: '白',
      youBlack: 'あなた（黒）',
      aiWhite: 'AI（白）',
      vs: 'vs'
    },
    side: {
      moveListAria: '棋譜',
      title: '棋譜',
      legendBoard:
        '盤面の数字はその手で色が付いた手番。下線はその手で裏返った石。',
      legendReplay: ' 終局後、棋譜や「初期形」から局面を辿れます。',
      initial: '初期形',
      initialHint: '中央4石',
      moveNo: '第 {n} 手',
      flipCount: '反転 {c}',
      finalTitle: '終局',
      scoreLine: '黒 {b} — 白 {w}',
      playAgain: 'もう一局',
      restart: '最初から',
      replayNav: '局面送り',
      prevStep: '一手戻る',
      nextStep: '一手進む',
      exportJson: 'JSON 書き出し',
      importJson: 'JSON 読み込み',
      importFailed: '読み込み失敗：',
      importOk: '棋譜を読み込みました。',
      saveLocal: '保存',
      saveOk: 'ブラウザに保存しました。',
      savedBrowserTitle: 'ブラウザの保存',
      saveListEmpty: '保存はまだありません。手順があるときに「保存」を押してください。',
      reviewBrowserSave: '再現',
      deleteBrowserSave: '削除',
      savedMoveCount: '{n} 手',
      saveQuota: 'ブラウザの保存領域がいっぱいです。古い保存を削除してから再度お試しください。',
      confirmDeleteSave: 'この保存を削除しますか？'
    }
  },
  ko: {
    meta: { versionLabel: 'v3.1', pageTitle: '오셀로 Othello v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: '언어' },
    help: { aboutAria: '오셀로 정보' },
    dialog: { close: '닫기' },
    about: {
      title: '오셀로 / 리버시 소개',
      body:
        '오셀로는 19세기 말 영국의 리버시에서 발전한 보드게임입니다. 8×8 보드에서 번갈아 돌을 놓고, 새로 놓은 돌과 같은 색 돌 사이에 직선으로 끼인 상대 돌은 모두 뒤집힙니다. 양쪽 모두 둘 곳이 없으면 종료되며, 돌이 더 많은 쪽이 승리합니다.'
    },
    status: {
      toMove: '{name}의 차례를 기다리는 중, {sec}초 생각 중'
    },
    game: {
      skipLine: '{who}은(는) 둘 수 없어 패스합니다.',
      resultDraw: '무승부!',
      resultNamedWin: '{name} 승리!'
    },
    roles: { you: '당신', ai: 'AI', black: '흑', white: '백', youBlack: '당신(흑)', aiWhite: 'AI(백)' },
    player: {
      sectionTitle: '플레이어 이름',
      labelBlack: '흑',
      labelWhite: '백',
      default1: '플레이어1',
      default2: '플레이어2'
    },
    mode: { pvp: '2인 대전', pvc: 'AI 대전', moveAssist: '착수 보조' },
    scoreboard: { blackPvp: '흑', whitePvp: '백', youBlack: '당신(흑)', aiWhite: 'AI(백)', vs: 'vs' },
    side: {
      moveListAria: '수순 기록',
      title: '대국 진행',
      legendBoard:
        '돌 위 숫자는 해당 색이 된 수순이며, 밑줄은 그 수에 뒤집힌 돌입니다.',
      legendReplay: ' 종국 후 수순 또는 “초기 배치”를 눌러 복기할 수 있습니다.',
      initial: '초기 배치',
      initialHint: '초기 4돌',
      moveNo: '{n}수',
      flipCount: '{c}개 뒤집기',
      finalTitle: '종국',
      scoreLine: '흑 {b} — 백 {w}',
      playAgain: '다시 한 판',
      restart: '재시작',
      replayNav: '복기 이동',
      prevStep: '이전',
      nextStep: '다음',
      exportJson: 'JSON 내보내기',
      importJson: 'JSON 불러오기',
      importFailed: '불러오기 실패:',
      importOk: '기보를 불러왔습니다.',
      saveLocal: '저장',
      saveOk: '브라우저에 저장되었습니다.',
      savedBrowserTitle: '브라우저 저장',
      saveListEmpty: '저장된 기보가 없습니다. 수순이 있을 때 저장하세요.',
      reviewBrowserSave: '복기',
      deleteBrowserSave: '삭제',
      savedMoveCount: '{n}수',
      saveQuota: '브라우저 저장 공간이 가득 찼습니다. 오래된 저장을 삭제 후 다시 시도하세요.',
      confirmDeleteSave: '이 저장을 삭제할까요?'
    }
  },
  fr: {
    meta: { versionLabel: 'v3.1', pageTitle: 'Othello v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: 'Langue' },
    help: { aboutAria: 'À propos d’Othello' },
    dialog: { close: 'Fermer' },
    about: {
      title: 'À propos d’Othello / Reversi',
      body:
        'Othello vient du Reversi anglais de la fin du XIXe siècle. Sur un plateau 8×8, les joueurs posent alternativement un pion ; tous les pions adverses pris en ligne droite entre deux pions de votre couleur sont retournés. Quand aucun joueur ne peut jouer, la partie se termine ; le plus grand nombre de pions gagne.'
    },
    status: {
      toMove: 'En attente de {name}, réflexion {sec}s'
    },
    game: {
      skipLine: '{who} ne peut pas jouer. Passe.',
      resultDraw: 'Égalité !',
      resultNamedWin: '{name} gagne !'
    },
    roles: { you: 'Vous', ai: 'IA', black: 'Noir', white: 'Blanc', youBlack: 'Vous (Noir)', aiWhite: 'IA (Blanc)' },
    player: {
      sectionTitle: 'Noms des joueurs',
      labelBlack: 'Noir',
      labelWhite: 'Blanc',
      default1: 'Joueur 1',
      default2: 'Joueur 2'
    },
    mode: { pvp: 'Deux joueurs', pvc: 'vs IA', moveAssist: 'Aide au coup' },
    scoreboard: { blackPvp: 'Noir', whitePvp: 'Blanc', youBlack: 'Vous (N)', aiWhite: 'IA (B)', vs: 'vs' },
    side: {
      moveListAria: 'Liste des coups',
      title: 'Progression',
      legendBoard:
        'Le numéro indique le coup où le pion a pris sa couleur ; souligné = pion retourné à ce coup.',
      legendReplay: ' En fin de partie, cliquez un coup ou “Position initiale” pour rejouer.',
      initial: 'Position initiale',
      initialHint: 'Quatre pions initiaux',
      moveNo: 'Coup {n}',
      flipCount: '{c} retourné(s)',
      finalTitle: 'Fin de partie',
      scoreLine: 'Noir {b} — Blanc {w}',
      playAgain: 'Rejouer',
      restart: 'Redémarrer',
      replayNav: 'Navigation',
      prevStep: 'Précédent',
      nextStep: 'Suivant',
      exportJson: 'Exporter JSON',
      importJson: 'Importer JSON',
      importFailed: 'Importation échouée :',
      importOk: 'Partie importée.',
      saveLocal: 'Enregistrer',
      saveOk: 'Enregistré dans ce navigateur.',
      savedBrowserTitle: 'Sauvegardes navigateur',
      saveListEmpty: 'Aucune sauvegarde pour le moment.',
      reviewBrowserSave: 'Revoir',
      deleteBrowserSave: 'Supprimer',
      savedMoveCount: '{n} coups',
      saveQuota: 'Stockage navigateur plein. Supprimez une ancienne sauvegarde puis réessayez.',
      confirmDeleteSave: 'Supprimer cette sauvegarde ?'
    }
  },
  de: {
    meta: { versionLabel: 'v3.1', pageTitle: 'Othello v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: 'Sprache' },
    help: { aboutAria: 'Über Othello' },
    dialog: { close: 'Schließen' },
    about: {
      title: 'Über Othello / Reversi',
      body:
        'Othello stammt vom englischen Reversi des späten 19. Jahrhunderts ab. Auf einem 8×8-Brett setzen Spieler abwechselnd Steine; gegnerische Steine, die in einer Linie zwischen zwei eigenen liegen, werden umgedreht. Wenn beide Seiten keinen Zug mehr haben, endet das Spiel; wer mehr Steine hat, gewinnt.'
    },
    status: {
      toMove: 'Warte auf {name}, denkt seit {sec}s'
    },
    game: {
      skipLine: '{who} hat keinen gültigen Zug. Aussetzen.',
      resultDraw: 'Unentschieden!',
      resultNamedWin: '{name} gewinnt!'
    },
    roles: { you: 'Du', ai: 'KI', black: 'Schwarz', white: 'Weiß', youBlack: 'Du (S)', aiWhite: 'KI (W)' },
    player: {
      sectionTitle: 'Spielernamen',
      labelBlack: 'Schwarz',
      labelWhite: 'Weiß',
      default1: 'Spieler 1',
      default2: 'Spieler 2'
    },
    mode: { pvp: 'Zwei Spieler', pvc: 'gegen KI', moveAssist: 'Zughilfe' },
    scoreboard: { blackPvp: 'Schwarz', whitePvp: 'Weiß', youBlack: 'Du (S)', aiWhite: 'KI (W)', vs: 'vs' },
    side: {
      moveListAria: 'Zugliste',
      title: 'Spielverlauf',
      legendBoard:
        'Zahlen zeigen den Zug, in dem der Stein seine Farbe erhielt; unterstrichen = in diesem Zug gedreht.',
      legendReplay: ' Nach Spielende kann man Züge oder “Startposition” zur Analyse wählen.',
      initial: 'Startposition',
      initialHint: 'Vier Startsteine',
      moveNo: 'Zug {n}',
      flipCount: '{c} gedreht',
      finalTitle: 'Ergebnis',
      scoreLine: 'Schwarz {b} — Weiß {w}',
      playAgain: 'Nochmal spielen',
      restart: 'Neu starten',
      replayNav: 'Analyse',
      prevStep: 'Zurück',
      nextStep: 'Weiter',
      exportJson: 'JSON exportieren',
      importJson: 'JSON importieren',
      importFailed: 'Import fehlgeschlagen:',
      importOk: 'Partie importiert.',
      saveLocal: 'Speichern',
      saveOk: 'Im Browser gespeichert.',
      savedBrowserTitle: 'Browser-Speicherstände',
      saveListEmpty: 'Noch keine Speicherstände vorhanden.',
      reviewBrowserSave: 'Analysieren',
      deleteBrowserSave: 'Löschen',
      savedMoveCount: '{n} Züge',
      saveQuota: 'Browser-Speicher voll. Alte Speicherstände löschen und erneut versuchen.',
      confirmDeleteSave: 'Diesen Speicherstand löschen?'
    }
  },
  ru: {
    meta: { versionLabel: 'v3.1', pageTitle: 'Отелло Othello v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: 'Язык' },
    help: { aboutAria: 'Об Othello' },
    dialog: { close: 'Закрыть' },
    about: {
      title: 'Об Othello / Reversi',
      body:
        'Othello происходит от английской игры Reversi конца XIX века. На доске 8×8 игроки по очереди ставят фишки; фишки соперника, зажатые по прямой между двумя вашими, переворачиваются. Когда ходов нет у обеих сторон, партия заканчивается; побеждает игрок с большим числом фишек.'
    },
    status: {
      toMove: 'Ожидание хода {name}, думает {sec} с'
    },
    game: {
      skipLine: '{who} не может ходить. Пропуск.',
      resultDraw: 'Ничья!',
      resultNamedWin: '{name} победил(а)!'
    },
    roles: { you: 'Вы', ai: 'ИИ', black: 'Чёрные', white: 'Белые', youBlack: 'Вы (Ч)', aiWhite: 'ИИ (Б)' },
    player: {
      sectionTitle: 'Имена игроков',
      labelBlack: 'Чёрные',
      labelWhite: 'Белые',
      default1: 'Игрок 1',
      default2: 'Игрок 2'
    },
    mode: { pvp: 'Два игрока', pvc: 'против ИИ', moveAssist: 'Подсказка хода' },
    scoreboard: { blackPvp: 'Чёрные', whitePvp: 'Белые', youBlack: 'Вы (Ч)', aiWhite: 'ИИ (Б)', vs: 'vs' },
    side: {
      moveListAria: 'Список ходов',
      title: 'Ход партии',
      legendBoard:
        'Числа на фишках — номер хода, когда фишка получила цвет; подчёркнута = перевёрнута на этом ходу.',
      legendReplay: ' После окончания можно выбрать ход или “Стартовая позиция” для разбора.',
      initial: 'Стартовая позиция',
      initialHint: 'Четыре стартовые фишки',
      moveNo: 'Ход {n}',
      flipCount: 'Перевёрнуто {c}',
      finalTitle: 'Итог',
      scoreLine: 'Чёрные {b} — Белые {w}',
      playAgain: 'Сыграть ещё',
      restart: 'Начать заново',
      replayNav: 'Навигация',
      prevStep: 'Назад',
      nextStep: 'Вперёд',
      exportJson: 'Экспорт JSON',
      importJson: 'Импорт JSON',
      importFailed: 'Ошибка импорта:',
      importOk: 'Партия импортирована.',
      saveLocal: 'Сохранить',
      saveOk: 'Сохранено в браузере.',
      savedBrowserTitle: 'Сохранения в браузере',
      saveListEmpty: 'Пока нет сохранений.',
      reviewBrowserSave: 'Разбор',
      deleteBrowserSave: 'Удалить',
      savedMoveCount: '{n} ходов',
      saveQuota: 'Хранилище браузера заполнено. Удалите старые сохранения и повторите.',
      confirmDeleteSave: 'Удалить это сохранение?'
    }
  },
  es: {
    meta: { versionLabel: 'v3.1', pageTitle: 'Othello v3.1' },
    title: { cn: '黑白棋', en: 'Othello' },
    lang: { label: 'Idioma' },
    help: { aboutAria: 'Acerca de Othello' },
    dialog: { close: 'Cerrar' },
    about: {
      title: 'Acerca de Othello / Reversi',
      body:
        'Othello desciende del juego inglés Reversi de finales del siglo XIX. En un tablero de 8×8, los jugadores colocan fichas por turnos; las fichas rivales atrapadas en línea recta entre dos propias se voltean. Cuando ninguno puede mover, la partida termina y gana quien tenga más fichas.'
    },
    status: {
      toMove: 'Esperando a {name}, pensando {sec}s'
    },
    game: {
      skipLine: '{who} no tiene jugadas legales. Pasa.',
      resultDraw: '¡Empate!',
      resultNamedWin: '¡{name} gana!'
    },
    roles: { you: 'Tú', ai: 'IA', black: 'Negras', white: 'Blancas', youBlack: 'Tú (N)', aiWhite: 'IA (B)' },
    player: {
      sectionTitle: 'Nombres de jugador',
      labelBlack: 'Negras',
      labelWhite: 'Blancas',
      default1: 'Jugador 1',
      default2: 'Jugador 2'
    },
    mode: { pvp: 'Dos jugadores', pvc: 'vs IA', moveAssist: 'Ayuda de jugada' },
    scoreboard: { blackPvp: 'Negras', whitePvp: 'Blancas', youBlack: 'Tú (N)', aiWhite: 'IA (B)', vs: 'vs' },
    side: {
      moveListAria: 'Lista de jugadas',
      title: 'Progreso',
      legendBoard:
        'Los números indican en qué turno una ficha obtuvo su color; subrayada = volteada en ese turno.',
      legendReplay: ' Al terminar, toca una jugada o “Inicio” para revisar.',
      initial: 'Posición inicial',
      initialHint: 'Cuatro fichas iniciales',
      moveNo: 'Jugada {n}',
      flipCount: 'Volteadas {c}',
      finalTitle: 'Resultado',
      scoreLine: 'Negras {b} — Blancas {w}',
      playAgain: 'Jugar de nuevo',
      restart: 'Reiniciar',
      replayNav: 'Revisión',
      prevStep: 'Anterior',
      nextStep: 'Siguiente',
      exportJson: 'Exportar JSON',
      importJson: 'Importar JSON',
      importFailed: 'Error al importar:',
      importOk: 'Partida importada.',
      saveLocal: 'Guardar',
      saveOk: 'Guardado en este navegador.',
      savedBrowserTitle: 'Guardados del navegador',
      saveListEmpty: 'Aún no hay guardados.',
      reviewBrowserSave: 'Revisar',
      deleteBrowserSave: 'Eliminar',
      savedMoveCount: '{n} jugadas',
      saveQuota: 'El almacenamiento del navegador está lleno. Elimina un guardado antiguo e inténtalo de nuevo.',
      confirmDeleteSave: '¿Eliminar este guardado?'
    }
  }
}
